import React from 'react';
import styled from 'styled-components';
import CachedViewRefresher from '@/containers/CachedViewRefresher';
import { Tooltip } from '@trevor/ui-components';
import { useLoadRows_LEGACY } from '@/features/query-builder/hooks/LEGACY';
import { useModal } from '@/features/modals/modalSlice';
import { RefreshResultsButton } from './RefreshResultsButton';
import { Pagination } from './Pagination';
import { MoreResultsExplainerModal } from './MoreResultsExplainerModal';
import { ResultsInfo } from './ResultsInfo';

export const Footer = () => {
  const { rowCount } = useLoadRows_LEGACY();

  const areMoreResultsLoaded = Boolean(rowCount && rowCount > 100);

  const InfoContainer = areMoreResultsLoaded
    ? MoreResultsExplainerTrigger
    : IdentityComponent;

  return (
    <>
      <CachedViewRefresher />
      <Container data-testid="results-footer-feedback">
        <InfoContainer rowCount={rowCount}>
          <ResultsInfo />
        </InfoContainer>

        <RefreshResultsButton />

        <Pagination />
      </Container>
    </>
  );
};

const MoreResultsContainer = styled.div`
  > span {
    border-bottom: 1px dashed gray;
    cursor: pointer;
  }
`;

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const IdentityComponent: React.FC = ({ children }) => children;

const MoreResultsExplainerTrigger: React.FC<{ rowCount: number }> = ({
  children,
  rowCount,
}) => {
  const [isOpen, handleOpen] = useModal();

  return (
    <>
      <MoreResultsContainer data-tooltip-id="rowCount" onClick={handleOpen}>
        {children}
        <Tooltip id="rowCount" place="top">
          Click to learn more
        </Tooltip>
      </MoreResultsContainer>
      {isOpen && <MoreResultsExplainerModal rowCount={rowCount} />}
    </>
  );
};

const Container = styled.div`
  display: flex;
  gap: var(--spacing-xs);
  height: 60px;
  align-items: center;
  font-size: 13px;

  border-top: 1px solid #e8e8e8;
  padding: 10px 95px 10px 20px;
`;
